var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.229 3.57338C16.6277 3.59816 17.0285 3.6264 17.4322 3.6581C18.5712 3.74752 19.5144 4.68944 19.6204 5.9208C19.849 8.57836 20.0778 11.261 20.0778 14.0001C20.0778 16.7391 19.849 19.4218 19.6204 22.0794C19.5144 23.3108 18.5712 24.2526 17.4322 24.342C13.7319 24.6326 10.2678 24.6326 6.56756 24.342C5.42848 24.2526 4.48531 23.3108 4.37939 22.0794C4.15075 19.4218 3.92187 16.7391 3.92187 14.0001C3.92187 11.261 4.15076 8.57836 4.37938 5.9208C4.48532 4.68944 5.42848 3.74752 6.56756 3.6581C6.97124 3.6264 7.37211 3.59816 7.77079 3.57338C7.84617 4.422 7.91768 5.26282 7.97869 6.04004C8.05367 6.99468 8.78273 7.78004 9.73728 7.85622C11.2732 7.97882 12.7266 7.97882 14.2625 7.85622C15.217 7.78004 15.9461 6.99468 16.0211 6.04004C16.0821 5.26282 16.1536 4.42202 16.229 3.57338ZM17.667 0.667296C13.8104 0.364482 10.1893 0.364482 6.33272 0.667296C3.63847 0.878846 1.61405 3.06404 1.39041 5.66366C1.16329 8.30398 0.921875 11.1122 0.921875 14.0001C0.921875 16.888 1.16329 19.6962 1.39041 22.3366C1.61405 24.9362 3.63847 27.1214 6.33272 27.3328C10.1893 27.6356 13.8104 27.6356 17.667 27.3328C20.3612 27.1214 22.3856 24.9362 22.6094 22.3366C22.8364 19.6962 23.0778 16.888 23.0778 14.0001C23.0778 11.1122 22.8364 8.30398 22.6094 5.66366C22.3856 3.06404 20.3612 0.878846 17.667 0.667296Z",
    fill: "url(#paint0_linear_3_202)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_202",
    x1: 4.7356,
    y1: 16.8177,
    x2: 22.9401,
    y2: 17.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3965FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#0071F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#0096F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E6F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpOther);
export default __webpack_public_path__ + "static/media/exp-other.efafda81cf042c1752ed053f7df249d9.svg";
export { ForwardRef as ReactComponent };